
if (typeof (window) !== 'undefined' && window.performance && window.performance.mark) {
  window.performance.mark('yotpo:loader:loaded');
}
var yotpoWidgetsContainer = yotpoWidgetsContainer || { guids: {} };
(function(){
    var guid = "t8qnZXgIaD5VegJXul3Q5A";
    var loader = {
        loadDep: function (link, onLoad, strategy) {
            var script = document.createElement('script');
            script.onload = onLoad || function(){};
            script.src = link;
            if (strategy === 'defer') {
                script.defer = true;
            } else if (strategy === 'async') {
                script.async = true;
            }
            script.setAttribute("type", "text/javascript");
            script.setAttribute("charset", "utf-8");
            document.head.appendChild(script);
        },
        config: {
            data: {
                guid: guid
            },
            widgets: {
            
                "1298007": {
                    instanceId: "1298007",
                    instanceVersionId: "498756885",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-spotlight/app.v0.19.0-375.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "apply-reward-button-text": "Apply to cart",
                      "body-color": "#000000",
                      "body-font-fallback-families": "sans-serif",
                      "body-font-family": "Assistant",
                      "body-font-style": "normal",
                      "body-font-weight": "400",
                      "button-bg-color": "#000000",
                      "button-text-color": "#ffffff",
                      "cart-requirement-text": "Requires ##value## in cart",
                      "days-left-text": "##days## day(s) left",
                      "direct-rewards-label": "Free",
                      "example-background-color": "#3184ed",
                      "expiry-date-format": "long",
                      "expiry-label": "exp.",
                      "greeting-text": "Hey ##name##,\nCheck out your perks",
                      "heading-color": "#000000",
                      "heading-font-fallback-families": "sans-serif",
                      "heading-font-family": "Assistant",
                      "heading-font-style": "normal",
                      "heading-font-weight": "400",
                      "item-requirement-text": "Requires item in cart",
                      "loyalty-name": "My Loyalty Program",
                      "points-bg-color": "#D6D6D6",
                      "points-label": "points",
                      "points-requirement-text": "Requires ##points## more pts",
                      "points-section-label": "You Earned",
                      "points-worth-label": "Worth",
                      "primary-font-name-and-url": "Montserrat@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css?family=Montserrat:600\u0026display=swap",
                      "primary-font-size": "14",
                      "remove-reward-button-text": "Remove from cart",
                      "reward-expiry-color": "#C93400",
                      "rewards-section-title": "Your Rewards",
                      "screen-a-header-text": "Hello Live Widget!",
                      "show-points-expiry": "true",
                      "tier-suffix": "Member"
                    },
                    staticContent: null,
                    className: "LoyaltySpotlightWidget",
                    dependencyGroupId: null
                },
            
                "1065279": {
                    instanceId: "1065279",
                    instanceVersionId: "326878436",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v1.8.1-4652.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba( 255, 255, 255, 1 )",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_57_17_569",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $25 off on their first order of $100+ and get $25 in points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $25, GET $25",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba( 55, 51, 48, 1 )",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their emails",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "fonts-secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "header-color": "rgba( 0, 0, 0, 1 )",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba( 118, 140,  220, 1 )",
                      "next-button-font-size": "18px",
                      "next-button-size": "standard",
                      "next-button-text-color": "rgba( 118, 140,  220, 1 )",
                      "next-button-type": "rectangular_outline",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "COMPLETED",
                      "referral-history-pending-status": "PENDING",
                      "referral-history-redeem-text": "To redeem your points, simply apply your discount at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Earn A Discount When You Shop Today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "medium",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba( 255, 255, 255, 1 )",
                      "title-color": "rgba( 55, 51, 48, 1 )",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-popup-delay-ms": 0,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#558342",
                      "view-table-theme": "dark",
                      "view-table-type": "rectangular",
                      "wadmin-text-and-share-choose-sreen": "step_1"
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "1065278": {
                    instanceId: "1065278",
                    instanceVersionId: "326878435",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v0.6.1-4815.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "layout-background-color": "white",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "500 points",
                      "redemption-1-settings-cost-color": "#666d8b",
                      "redemption-1-settings-cost-font-size": "20",
                      "redemption-1-settings-reward": "$5",
                      "redemption-1-settings-reward-color": "#011247",
                      "redemption-1-settings-reward-font-size": "30",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "1000 points",
                      "redemption-2-settings-cost-color": "#666d8b",
                      "redemption-2-settings-cost-font-size": "20",
                      "redemption-2-settings-reward": "$10",
                      "redemption-2-settings-reward-color": "#011247",
                      "redemption-2-settings-reward-font-size": "30",
                      "redemption-233955-displayname": "Tile 4 (233955)",
                      "redemption-233955-settings-cost": "5000 points",
                      "redemption-233955-settings-cost-color": "#666d8b",
                      "redemption-233955-settings-cost-font-size": "20",
                      "redemption-233955-settings-reward": "$50",
                      "redemption-233955-settings-reward-color": "#011247",
                      "redemption-233955-settings-reward-font-size": "30",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "2000 points",
                      "redemption-3-settings-cost-color": "#666d8b",
                      "redemption-3-settings-cost-font-size": "20",
                      "redemption-3-settings-reward": "$20",
                      "redemption-3-settings-reward-color": "#011247",
                      "redemption-3-settings-reward-font-size": "30",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3",
                        "233955"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your hard-earned points is easy! Simply apply your points for a discount at checkout!",
                      "visual-redemption-headline": "How to use your points",
                      "visual-redemption-rule": "100 points equals $1.00"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1065277": {
                    instanceId: "1065277",
                    instanceVersionId: "326878434",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-loyalty-campaigns/app.v0.7.0-2646.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/t8qnZXgIaD5VegJXul3Q5A/css-overrides/css-overrides.2021_11_17_10_37_05_230.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#4e5772",
                      "campaign-description-size": "18px",
                      "campaign-item-050135-action-tile-action-text": "Click here",
                      "campaign-item-050135-action-tile-title": "Earn points for an action",
                      "campaign-item-050135-background-color": "#f9faff",
                      "campaign-item-050135-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-050135-background-type": "color",
                      "campaign-item-050135-border-color": "#848ca3",
                      "campaign-item-050135-description-font-color": "#4e5772",
                      "campaign-item-050135-description-font-size": "18",
                      "campaign-item-050135-displayname": "Like On Facebook (050135)",
                      "campaign-item-050135-icon-color": "#768cdc",
                      "campaign-item-050135-icon-type": "customIcon",
                      "campaign-item-050135-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_05_17_813",
                      "campaign-item-050135-tile-description": "Like on Facebook",
                      "campaign-item-050135-tile-reward": "20 points",
                      "campaign-item-050135-title-font-color": "#011247",
                      "campaign-item-050135-title-font-size": "27",
                      "campaign-item-050135-type": "FreeTextCampaign",
                      "campaign-item-050135-view-show-custom-action-button": "false",
                      "campaign-item-1010821-background-color": "#f9faff",
                      "campaign-item-1010821-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010821-background-type": "color",
                      "campaign-item-1010821-border-color": "#848ca3",
                      "campaign-item-1010821-description-font-color": "#4e5772",
                      "campaign-item-1010821-description-font-size": "18",
                      "campaign-item-1010821-hover-view-tile-message": "Earn 120 points when you create an account",
                      "campaign-item-1010821-icon-color": "#768cdc",
                      "campaign-item-1010821-icon-type": "customIcon",
                      "campaign-item-1010821-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_06_49_282",
                      "campaign-item-1010821-tile-description": "Create an account",
                      "campaign-item-1010821-tile-reward": "120 Points",
                      "campaign-item-1010821-title-font-color": "#011247",
                      "campaign-item-1010821-title-font-size": "27",
                      "campaign-item-1010821-type": "CreateAccountCampaign",
                      "campaign-item-1010822-action-tile-action-text": "Add My Birthday",
                      "campaign-item-1010822-action-tile-birthday-ask-year": "false",
                      "campaign-item-1010822-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1010822-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1010822-action-tile-title": "Earn 140 points on your birthday",
                      "campaign-item-1010822-background-color": "#f9faff",
                      "campaign-item-1010822-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010822-background-type": "color",
                      "campaign-item-1010822-border-color": "#848ca3",
                      "campaign-item-1010822-description-font-color": "#4e5772",
                      "campaign-item-1010822-description-font-size": "18",
                      "campaign-item-1010822-icon-color": "#768cdc",
                      "campaign-item-1010822-icon-type": "customIcon",
                      "campaign-item-1010822-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_08_07_959",
                      "campaign-item-1010822-tile-description": "Happy Birthday!",
                      "campaign-item-1010822-tile-reward": "140 Points",
                      "campaign-item-1010822-title-font-color": "#011247",
                      "campaign-item-1010822-title-font-size": "27",
                      "campaign-item-1010822-type": "BirthdayCampaign",
                      "campaign-item-1010823-background-color": "#f9faff",
                      "campaign-item-1010823-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010823-background-type": "color",
                      "campaign-item-1010823-border-color": "#848ca3",
                      "campaign-item-1010823-description-font-color": "#4e5772",
                      "campaign-item-1010823-description-font-size": "18",
                      "campaign-item-1010823-hover-view-tile-message": "Earn 1 points for every $1.00 you spend in our store",
                      "campaign-item-1010823-icon-color": "#768cdc",
                      "campaign-item-1010823-icon-type": "customIcon",
                      "campaign-item-1010823-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_07_48_664",
                      "campaign-item-1010823-tile-description": "Make a purchase",
                      "campaign-item-1010823-tile-reward": "1 Points Per $1.00",
                      "campaign-item-1010823-title-font-color": "#011247",
                      "campaign-item-1010823-title-font-size": "27",
                      "campaign-item-1010823-type": "PointsForPurchasesCampaign",
                      "campaign-item-1010839-action-tile-action-text": "Share on Facebook",
                      "campaign-item-1010839-action-tile-title": "Earn 40 points when you share us on Facebook",
                      "campaign-item-1010839-background-color": "#f9faff",
                      "campaign-item-1010839-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010839-background-type": "color",
                      "campaign-item-1010839-border-color": "#848ca3",
                      "campaign-item-1010839-description-font-color": "#4e5772",
                      "campaign-item-1010839-description-font-size": "18",
                      "campaign-item-1010839-icon-color": "#768cdc",
                      "campaign-item-1010839-icon-type": "customIcon",
                      "campaign-item-1010839-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_06_07_444",
                      "campaign-item-1010839-tile-description": "Share On Facebook",
                      "campaign-item-1010839-tile-reward": "40 points",
                      "campaign-item-1010839-title-font-color": "#011247",
                      "campaign-item-1010839-title-font-size": "27",
                      "campaign-item-1010839-type": "FacebookShareCampaign",
                      "campaign-item-1010840-background-color": "#f9faff",
                      "campaign-item-1010840-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010840-background-type": "color",
                      "campaign-item-1010840-border-color": "#848ca3",
                      "campaign-item-1010840-description-font-color": "#4e5772",
                      "campaign-item-1010840-description-font-size": "18",
                      "campaign-item-1010840-hover-view-tile-message": "Earn 100 points for leaving a review",
                      "campaign-item-1010840-icon-color": "#768cdc",
                      "campaign-item-1010840-icon-type": "customIcon",
                      "campaign-item-1010840-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_06_34_293",
                      "campaign-item-1010840-tile-description": "Leave a Review",
                      "campaign-item-1010840-tile-reward": "100 points",
                      "campaign-item-1010840-title-font-color": "#011247",
                      "campaign-item-1010840-title-font-size": "27",
                      "campaign-item-1010840-type": "YotpoReviewCampaign",
                      "campaign-item-1014496-action-tile-action-text": "Follow Us",
                      "campaign-item-1014496-action-tile-title": "Earn 100 points when you follow us on Instagram",
                      "campaign-item-1014496-background-color": "#f9faff",
                      "campaign-item-1014496-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014496-background-type": "color",
                      "campaign-item-1014496-border-color": "#848ca3",
                      "campaign-item-1014496-description-font-color": "#4e5772",
                      "campaign-item-1014496-description-font-size": "18",
                      "campaign-item-1014496-icon-color": "#768cdc",
                      "campaign-item-1014496-icon-type": "customIcon",
                      "campaign-item-1014496-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_07_01_702",
                      "campaign-item-1014496-tile-description": "Follow us on Instagram",
                      "campaign-item-1014496-tile-reward": "100 points",
                      "campaign-item-1014496-title-font-color": "#011247",
                      "campaign-item-1014496-title-font-size": "27",
                      "campaign-item-1014496-type": "InstagramFollowCampaign",
                      "campaign-item-1014518-action-tile-action-text": "Add My Anniversary",
                      "campaign-item-1014518-action-tile-final-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1014518-action-tile-message-text": "If your anniversary is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1014518-action-tile-title": "Earn 140 points on your anniversary",
                      "campaign-item-1014518-background-color": "#f9faff",
                      "campaign-item-1014518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014518-background-type": "color",
                      "campaign-item-1014518-border-color": "#848ca3",
                      "campaign-item-1014518-description-font-color": "#4e5772",
                      "campaign-item-1014518-description-font-size": "18",
                      "campaign-item-1014518-icon-color": "#768cdc",
                      "campaign-item-1014518-icon-type": "customIcon",
                      "campaign-item-1014518-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_10_04_863",
                      "campaign-item-1014518-tile-description": "Happy Anniversary",
                      "campaign-item-1014518-tile-reward": "140 Points",
                      "campaign-item-1014518-title-font-color": "#011247",
                      "campaign-item-1014518-title-font-size": "27",
                      "campaign-item-1014518-type": "AnniversaryCampaign",
                      "campaign-item-227931-action-tile-action-text": "Click here",
                      "campaign-item-227931-action-tile-title": "Earn points for an action",
                      "campaign-item-227931-background-color": "#f9faff",
                      "campaign-item-227931-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-227931-background-type": "color",
                      "campaign-item-227931-border-color": "#848ca3",
                      "campaign-item-227931-description-font-color": "#4e5772",
                      "campaign-item-227931-description-font-size": "18",
                      "campaign-item-227931-displayname": "Sign up for SMS (227931)",
                      "campaign-item-227931-icon-color": "#768cdc",
                      "campaign-item-227931-icon-type": "customIcon",
                      "campaign-item-227931-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_08_23_250",
                      "campaign-item-227931-tile-description": "Sign up for SMS",
                      "campaign-item-227931-tile-reward": "200 points",
                      "campaign-item-227931-title-font-color": "#011247",
                      "campaign-item-227931-title-font-size": "27",
                      "campaign-item-227931-type": "FreeTextCampaign",
                      "campaign-item-227931-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "#011247",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "Ways to Earn Points",
                      "general-hover-tile-button-color": "#ffffff",
                      "general-hover-tile-button-text-color": "rgba(2,40,74,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(2,40,74,1)",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "rgba(2,40,74,1)",
                      "headline-font-size": "36px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-text-font-name-and-url": "Montserrat@400|https://fonts.googleapis.com/css?family=Montserrat\u0026display=swap",
                      "selected-extensions": [
                        "050135",
                        "1010839",
                        "1010840",
                        "1010821",
                        "1014496",
                        "1010823",
                        "1010822",
                        "227931",
                        "1014518"
                      ],
                      "tile-border-color": "#848ca3",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#f9faff",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//georgestonecrab.com/account/login",
                      "storeAccountRegistrationUrl": "//georgestonecrab.com/account/register",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1065276": {
                    instanceId: "1065276",
                    instanceVersionId: "326878433",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-my-rewards/app.v0.1.10-2649.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/t8qnZXgIaD5VegJXul3Q5A/css-overrides/css-overrides.2021_11_17_10_32_39_413.css",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "#728be2",
                      "logged-in-description-font-size": "34",
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "#011247",
                      "logged-in-headline-font-size": "36",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "REDEEM NOW",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "rgba(255,255,255,1)",
                      "logged-out-headline-font-size": "36",
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_3",
                      "primary-button-background-color": "#728be2",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Join the reel rewards\nprogram and start earning.",
                      "reward-step-1-settings-description-color": "rgba(255,255,255,1)",
                      "reward-step-1-settings-description-font-size": "20",
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_36_06_937",
                      "reward-step-1-settings-title": "JOIN",
                      "reward-step-1-settings-title-color": "rgba(255,255,255,1)",
                      "reward-step-1-settings-title-font-size": "24",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "rgba(255,255,255,1)",
                      "reward-step-2-settings-description-font-size": "20",
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "rgba(255,255,255,1)",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_37_54_754",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "rgba(255,255,255,1)",
                      "reward-step-2-settings-title-font-size": "24",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive discounts.",
                      "reward-step-3-settings-description-color": "rgba(255,255,255,1)",
                      "reward-step-3-settings-description-font-size": "20",
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "rgba(255,255,255,1)",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_38_12_747",
                      "reward-step-3-settings-title": "REDEEM POINTS",
                      "reward-step-3-settings-title-color": "rgba(255,255,255,1)",
                      "reward-step-3-settings-title-font-size": "24",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "#10055c",
                      "rewards-history-headline-font-size": "28",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "#768cdc",
                      "secondary-button-text-color": "#768cdc",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-grid-points-column-color": "#7a97e8",
                      "view-grid-rectangular-background-color": "#e6ecff",
                      "view-grid-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1065275": {
                    instanceId: "1065275",
                    instanceVersionId: "326878432",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-hero-section/app.v0.1.6-2637.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/t8qnZXgIaD5VegJXul3Q5A/css-overrides/css-overrides.2021_11_17_10_38_30_501.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_49_33_311",
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "20",
                      "description-text-logged-in": "As a member you'll earn points \u0026 exclusive rewards every time you shop.",
                      "description-text-logged-out": "As a rewards member, you'll get closer to earning exclusive rewards every time you shop.",
                      "headline-color": "rgba(255,255,255,1)",
                      "headline-font-size": "40",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Rewards",
                      "login-button-color": "rgba(255,255,255,1)",
                      "login-button-text": "LOGIN",
                      "login-button-text-color": "rgba(255,255,255,1)",
                      "login-button-type": "rectangular_outline",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_50_01_767",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "register-button-color": "rgba(255,255,255,1)",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "rgba(13,59,112,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-layout": "right-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "//georgestonecrab.com/account/login",
                      "storeRegistrationUrl": "//georgestonecrab.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1060110": {
                    instanceId: "1060110",
                    instanceVersionId: "491181666",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.20-48.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "true",
                      "layout-background-color": "#F6F1EE",
                      "logged-in-description-color": "#0F8383",
                      "logged-in-description-font-size": "22",
                      "logged-in-description-text": "{{current_point_balance}} points",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "#000000",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How it Works",
                      "primary-button-background-color": "#000000",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "rounded_filled_rectangle",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nearn 100 points.",
                      "reward-step-1-settings-description-color": "#6C6C6C",
                      "reward-step-1-settings-description-font-size": "16",
                      "reward-step-1-settings-icon": "default",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-title": "Sign up",
                      "reward-step-1-settings-title-color": "#000000",
                      "reward-step-1-settings-title-font-size": "20",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "#6C6C6C",
                      "reward-step-2-settings-description-font-size": "16",
                      "reward-step-2-settings-icon": "default",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-title": "Earn points",
                      "reward-step-2-settings-title-color": "#000000",
                      "reward-step-2-settings-title-font-size": "20",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive rewards.",
                      "reward-step-3-settings-description-color": "#6C6C6C",
                      "reward-step-3-settings-description-font-size": "16",
                      "reward-step-3-settings-icon": "default",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-title": "Redeem points",
                      "reward-step-3-settings-title-color": "#000000",
                      "reward-step-3-settings-title-font-size": "20",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(0,0,0,0.79)",
                      "rewards-history-headline-color": "#000000",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "#000000",
                      "secondary-button-text-color": "#000000",
                      "secondary-button-type": "rounded_rectangle",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "#0F8383",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": false,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1060109": {
                    instanceId: "1060109",
                    instanceVersionId: "498694431",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.18-51.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1010821-background-color": "transparent",
                      "campaign-item-1010821-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010821-background-type": "color",
                      "campaign-item-1010821-border-color": "#BCBCBC",
                      "campaign-item-1010821-description-font-color": "#6c6c6c",
                      "campaign-item-1010821-description-font-size": "16",
                      "campaign-item-1010821-exclude_audience_ids": null,
                      "campaign-item-1010821-exclude_audience_names": [],
                      "campaign-item-1010821-hover-view-tile-message": "Earn 120 points when you create an account",
                      "campaign-item-1010821-icon-color": "#60a3a3",
                      "campaign-item-1010821-icon-type": "defaultIcon",
                      "campaign-item-1010821-include_audience_ids": "1",
                      "campaign-item-1010821-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010821-special-reward-enabled": "false",
                      "campaign-item-1010821-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010821-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010821-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010821-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010821-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010821-tile-description": "Create an account",
                      "campaign-item-1010821-tile-reward": "120 Points",
                      "campaign-item-1010821-title-font-color": "#000000",
                      "campaign-item-1010821-title-font-size": "18",
                      "campaign-item-1010821-type": "CreateAccountCampaign",
                      "campaign-item-1010822-action-tile-ask-year": "true",
                      "campaign-item-1010822-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-1010822-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1010822-action-tile-european-date-format": "false",
                      "campaign-item-1010822-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1010822-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1010822-action-tile-title": "Earn 140 points on your birthday",
                      "campaign-item-1010822-background-color": "transparent",
                      "campaign-item-1010822-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010822-background-type": "color",
                      "campaign-item-1010822-border-color": "#BCBCBC",
                      "campaign-item-1010822-description-font-color": "#6c6c6c",
                      "campaign-item-1010822-description-font-size": "16",
                      "campaign-item-1010822-exclude_audience_ids": null,
                      "campaign-item-1010822-exclude_audience_names": [],
                      "campaign-item-1010822-icon-color": "#60a3a3",
                      "campaign-item-1010822-icon-type": "defaultIcon",
                      "campaign-item-1010822-include_audience_ids": "1",
                      "campaign-item-1010822-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010822-special-reward-enabled": "false",
                      "campaign-item-1010822-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010822-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010822-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010822-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010822-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010822-tile-description": "Happy Birthday!",
                      "campaign-item-1010822-tile-reward": "140 Points",
                      "campaign-item-1010822-title-font-color": "#000000",
                      "campaign-item-1010822-title-font-size": "18",
                      "campaign-item-1010822-type": "BirthdayCampaign",
                      "campaign-item-1010823-background-color": "transparent",
                      "campaign-item-1010823-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010823-background-type": "color",
                      "campaign-item-1010823-border-color": "#BCBCBC",
                      "campaign-item-1010823-description-font-color": "#6c6c6c",
                      "campaign-item-1010823-description-font-size": "16",
                      "campaign-item-1010823-exclude_audience_ids": null,
                      "campaign-item-1010823-exclude_audience_names": [],
                      "campaign-item-1010823-hover-view-tile-message": "Earn 1 points for every $1.00 you spend in our store",
                      "campaign-item-1010823-icon-color": "#60a3a3",
                      "campaign-item-1010823-icon-type": "defaultIcon",
                      "campaign-item-1010823-include_audience_ids": "1",
                      "campaign-item-1010823-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010823-special-reward-enabled": "false",
                      "campaign-item-1010823-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010823-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010823-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010823-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010823-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010823-tile-description": "Make a purchase",
                      "campaign-item-1010823-tile-reward": "1 Points Per $1.00",
                      "campaign-item-1010823-title-font-color": "#000000",
                      "campaign-item-1010823-title-font-size": "18",
                      "campaign-item-1010823-type": "PointsForPurchasesCampaign",
                      "campaign-item-1010839-action-tile-action-text": "Share on Facebook",
                      "campaign-item-1010839-action-tile-title": "Earn 40 points when you share us on Facebook",
                      "campaign-item-1010839-background-color": "transparent",
                      "campaign-item-1010839-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010839-background-type": "color",
                      "campaign-item-1010839-border-color": "#BCBCBC",
                      "campaign-item-1010839-description-font-color": "#6c6c6c",
                      "campaign-item-1010839-description-font-size": "16",
                      "campaign-item-1010839-exclude_audience_ids": null,
                      "campaign-item-1010839-exclude_audience_names": [],
                      "campaign-item-1010839-icon-color": "#60a3a3",
                      "campaign-item-1010839-icon-type": "defaultIcon",
                      "campaign-item-1010839-include_audience_ids": "1",
                      "campaign-item-1010839-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010839-special-reward-enabled": "false",
                      "campaign-item-1010839-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010839-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010839-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010839-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010839-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010839-tile-description": "Share On Facebook",
                      "campaign-item-1010839-tile-reward": "40 Points",
                      "campaign-item-1010839-title-font-color": "#000000",
                      "campaign-item-1010839-title-font-size": "18",
                      "campaign-item-1010839-type": "FacebookShareCampaign",
                      "campaign-item-1010840-background-color": "transparent",
                      "campaign-item-1010840-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010840-background-type": "color",
                      "campaign-item-1010840-border-color": "#BCBCBC",
                      "campaign-item-1010840-description-font-color": "#6c6c6c",
                      "campaign-item-1010840-description-font-size": "16",
                      "campaign-item-1010840-exclude_audience_ids": null,
                      "campaign-item-1010840-exclude_audience_names": [],
                      "campaign-item-1010840-hover-view-tile-message": "Earn 100 points for leaving a review",
                      "campaign-item-1010840-icon-color": "#60a3a3",
                      "campaign-item-1010840-icon-type": "defaultIcon",
                      "campaign-item-1010840-include_audience_ids": "1",
                      "campaign-item-1010840-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010840-special-reward-enabled": "false",
                      "campaign-item-1010840-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010840-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010840-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010840-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010840-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010840-tile-description": "Leave a Review",
                      "campaign-item-1010840-tile-reward": "100 points",
                      "campaign-item-1010840-title-font-color": "#000000",
                      "campaign-item-1010840-title-font-size": "18",
                      "campaign-item-1010840-type": "YotpoReviewCampaign",
                      "campaign-item-1014496-action-tile-action-text": "Follow Us",
                      "campaign-item-1014496-action-tile-title": "Earn 100 points when you follow us on Instagram",
                      "campaign-item-1014496-background-color": "transparent",
                      "campaign-item-1014496-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014496-background-type": "color",
                      "campaign-item-1014496-border-color": "#BCBCBC",
                      "campaign-item-1014496-description-font-color": "#6c6c6c",
                      "campaign-item-1014496-description-font-size": "16",
                      "campaign-item-1014496-exclude_audience_ids": null,
                      "campaign-item-1014496-exclude_audience_names": [],
                      "campaign-item-1014496-icon-color": "#60a3a3",
                      "campaign-item-1014496-icon-type": "defaultIcon",
                      "campaign-item-1014496-include_audience_ids": "1",
                      "campaign-item-1014496-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1014496-special-reward-enabled": "false",
                      "campaign-item-1014496-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1014496-special-reward-headline-text": "Just for you!",
                      "campaign-item-1014496-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1014496-special-reward-headline-title-font-size": "12",
                      "campaign-item-1014496-special-reward-tile-border-color": "#000000",
                      "campaign-item-1014496-tile-description": "Follow us on Instagram",
                      "campaign-item-1014496-tile-reward": "100 Points",
                      "campaign-item-1014496-title-font-color": "#000000",
                      "campaign-item-1014496-title-font-size": "18",
                      "campaign-item-1014496-type": "InstagramFollowCampaign",
                      "campaign-item-1014517-background-color": "transparent",
                      "campaign-item-1014517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014517-background-type": "color",
                      "campaign-item-1014517-border-color": "#BCBCBC",
                      "campaign-item-1014517-description-font-color": "#6c6c6c",
                      "campaign-item-1014517-description-font-size": "16",
                      "campaign-item-1014517-exclude_audience_ids": null,
                      "campaign-item-1014517-exclude_audience_names": [],
                      "campaign-item-1014517-hover-view-tile-message": "Earn 400 points when you make 5 purchases",
                      "campaign-item-1014517-icon-color": "#60a3a3",
                      "campaign-item-1014517-icon-type": "defaultIcon",
                      "campaign-item-1014517-include_audience_ids": "1",
                      "campaign-item-1014517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1014517-special-reward-enabled": "false",
                      "campaign-item-1014517-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1014517-special-reward-headline-text": "Just for you!",
                      "campaign-item-1014517-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1014517-special-reward-headline-title-font-size": "12",
                      "campaign-item-1014517-special-reward-tile-border-color": "#000000",
                      "campaign-item-1014517-tile-description": "Make 5 Purchases",
                      "campaign-item-1014517-tile-reward": "400 Points",
                      "campaign-item-1014517-title-font-color": "#000000",
                      "campaign-item-1014517-title-font-size": "18",
                      "campaign-item-1014517-type": "TransactionBasedCampaign",
                      "campaign-item-1014518-action-tile-anniversary-required-field-message": "This field is required",
                      "campaign-item-1014518-action-tile-ask-year": "false",
                      "campaign-item-1014518-action-tile-european-date-format": "false",
                      "campaign-item-1014518-action-tile-final-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1014518-action-tile-message-text": "If your anniversary is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1014518-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1014518-action-tile-title": "Earn 140 points on your anniversary",
                      "campaign-item-1014518-background-color": "transparent",
                      "campaign-item-1014518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014518-background-type": "color",
                      "campaign-item-1014518-border-color": "#BCBCBC",
                      "campaign-item-1014518-description-font-color": "#6c6c6c",
                      "campaign-item-1014518-description-font-size": "16",
                      "campaign-item-1014518-exclude_audience_ids": null,
                      "campaign-item-1014518-exclude_audience_names": [],
                      "campaign-item-1014518-icon-color": "#60a3a3",
                      "campaign-item-1014518-icon-type": "defaultIcon",
                      "campaign-item-1014518-include_audience_ids": "1",
                      "campaign-item-1014518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1014518-special-reward-enabled": "false",
                      "campaign-item-1014518-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1014518-special-reward-headline-text": "Just for you!",
                      "campaign-item-1014518-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1014518-special-reward-headline-title-font-size": "12",
                      "campaign-item-1014518-special-reward-tile-border-color": "#000000",
                      "campaign-item-1014518-tile-description": "Happy Anniversary",
                      "campaign-item-1014518-tile-reward": "140 Points",
                      "campaign-item-1014518-title-font-color": "#000000",
                      "campaign-item-1014518-title-font-size": "18",
                      "campaign-item-1014518-type": "AnniversaryCampaign",
                      "campaign-item-1053255-action-tile-action-text": "Click Here",
                      "campaign-item-1053255-action-tile-title": "Earn 20 points when you share us on Facebook",
                      "campaign-item-1053255-background-color": "transparent",
                      "campaign-item-1053255-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1053255-background-type": "color",
                      "campaign-item-1053255-border-color": "#BCBCBC",
                      "campaign-item-1053255-description-font-color": "#6c6c6c",
                      "campaign-item-1053255-description-font-size": "16",
                      "campaign-item-1053255-exclude_audience_ids": null,
                      "campaign-item-1053255-exclude_audience_names": [],
                      "campaign-item-1053255-icon-color": "#60a3a3",
                      "campaign-item-1053255-icon-type": "defaultIcon",
                      "campaign-item-1053255-include_audience_ids": "1",
                      "campaign-item-1053255-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1053255-special-reward-enabled": "false",
                      "campaign-item-1053255-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1053255-special-reward-headline-text": "Just for you!",
                      "campaign-item-1053255-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1053255-special-reward-headline-title-font-size": "12",
                      "campaign-item-1053255-special-reward-tile-border-color": "#000000",
                      "campaign-item-1053255-tile-description": "Like on Facebook",
                      "campaign-item-1053255-tile-reward": "20 Points",
                      "campaign-item-1053255-title-font-color": "#000000",
                      "campaign-item-1053255-title-font-size": "18",
                      "campaign-item-1053255-type": "CustomActionCampaign",
                      "campaign-item-1053255-view-show-custom-action-button": "false",
                      "campaign-item-1156384-background-color": "transparent",
                      "campaign-item-1156384-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1156384-background-type": "color",
                      "campaign-item-1156384-border-color": "#BCBCBC",
                      "campaign-item-1156384-description-font-color": "#6c6c6c",
                      "campaign-item-1156384-description-font-size": "16",
                      "campaign-item-1156384-exclude_audience_ids": null,
                      "campaign-item-1156384-exclude_audience_names": [],
                      "campaign-item-1156384-hover-view-tile-message": "Earn 3 point for every $1 you spend in our store during Father's Day Week!",
                      "campaign-item-1156384-icon-color": "#60a3a3",
                      "campaign-item-1156384-icon-type": "defaultIcon",
                      "campaign-item-1156384-include_audience_ids": "1",
                      "campaign-item-1156384-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1156384-special-reward-enabled": "false",
                      "campaign-item-1156384-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1156384-special-reward-headline-text": "Just for you!",
                      "campaign-item-1156384-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1156384-special-reward-headline-title-font-size": "12",
                      "campaign-item-1156384-special-reward-tile-border-color": "#000000",
                      "campaign-item-1156384-tile-description": "Father's Day Week 3x",
                      "campaign-item-1156384-tile-reward": "Three Point Per Dollar Spent",
                      "campaign-item-1156384-title-font-color": "#000000",
                      "campaign-item-1156384-title-font-size": "18",
                      "campaign-item-1156384-type": "PointsForPurchasesCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "#000000",
                      "general-hover-tile-button-text-color": "#FFFFFF",
                      "general-hover-tile-button-type": "rounded_filled_rectangle",
                      "general-hover-tile-color-overlay": "#D2E3E3",
                      "general-hover-tile-text-color": "#000000",
                      "headline-font-color": "#000000",
                      "headline-font-size": "26px",
                      "layout-background-color": "#FFFFFF",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "secondary-text-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1053255",
                        "1010822",
                        "1010821",
                        "1010823",
                        "1010839",
                        "1010840",
                        "1014496",
                        "1014517",
                        "1014518",
                        "1156384"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": false,
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//georgestonecrab.com/account/login",
                      "storeAccountRegistrationUrl": "//georgestonecrab.com/account/register",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1060108": {
                    instanceId: "1060108",
                    instanceVersionId: "484912296",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.8.5-42.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/widget-hero-section/customizations/defaults/background-image.jpg",
                      "description-color": "#000000",
                      "description-font-size": "16",
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "#000000",
                      "login-button-text": "Log in",
                      "login-button-text-color": "#000000",
                      "login-button-type": "rounded_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/widget-hero-section/customizations/defaults/background-image-mobile.png",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "register-button-color": "#000000",
                      "register-button-text": "Join now",
                      "register-button-text-color": "#ffffff",
                      "register-button-type": "rounded_filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": "true",
                      "text-background-show-on-mobile": "true",
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": false,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "//georgestonecrab.com/account/login",
                      "storeRegistrationUrl": "//georgestonecrab.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1060107": {
                    instanceId: "1060107",
                    instanceVersionId: "483810380",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v2.5.20-15.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#F6F1EE",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/widget-referral-widget/customizations/defaults/background-image.jpg",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $10 off their first order of $5, and get 500 points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $10, GET 500 POINTS",
                      "customer-name-view-input-placeholder": "Your first name",
                      "default-toggle": true,
                      "description-color": "#6C6C6C",
                      "description-font-size": "16px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "fonts-secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "header-color": "#000000",
                      "header-font-size": "16px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "next-button-background-color": "#0F8383",
                      "next-button-font-size": "16px",
                      "next-button-size": "standard",
                      "next-button-text-color": "#FFFFFF",
                      "next-button-type": "rounded_filled_rectangle",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description": "Give your friends $10 off their first order of $5, and get 500 points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title": "GIVE $10, GET 500 POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Get a discount and shop today!",
                      "share-facebook-image-url": "",
                      "share-headline-text-color": "#6C6C6C",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "#F6F1EE",
                      "title-color": "#000000",
                      "title-font-size": "26px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "left",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines"
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": false,
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "1060106": {
                    instanceId: "1060106",
                    instanceVersionId: "483828041",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.7-18.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": false,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1060105": {
                    instanceId: "1060105",
                    instanceVersionId: "487830971",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.31-119.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.",
                      "coupons-redemption-headline": "How to Use Your Points",
                      "coupons-redemption-rule": "100 points equals $1",
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-add-background": "true",
                      "layout-background-color": "#F6F1EE",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "#0F8383",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "rounded_filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#000000",
                      "points-balance-font-size": "16",
                      "points-balance-number-color": "#0F8383",
                      "primary-font-name-and-url": "Poppins@600|https://fonts.googleapis.com/css?family=Poppins:600\u0026display=swap",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-591939-displayname": "$5.00 Off",
                      "redemption-591939-settings-button-color": "#0F8383",
                      "redemption-591939-settings-button-text": "Redeem",
                      "redemption-591939-settings-button-text-color": "#FFFFFF",
                      "redemption-591939-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591939-settings-call-to-action-button-text": "Redeem",
                      "redemption-591939-settings-cost": 500,
                      "redemption-591939-settings-cost-color": "#6C6C6C",
                      "redemption-591939-settings-cost-font-size": "16",
                      "redemption-591939-settings-cost-text": "{{points}} points",
                      "redemption-591939-settings-coupon-cost-font-size": "15",
                      "redemption-591939-settings-coupon-reward-font-size": "20",
                      "redemption-591939-settings-discount-amount-cents": 500,
                      "redemption-591939-settings-discount-type": "fixed_amount",
                      "redemption-591939-settings-reward": "$5.00 Off",
                      "redemption-591939-settings-reward-color": "#000000",
                      "redemption-591939-settings-reward-font-size": "20",
                      "redemption-591939-settings-success-message-text": "Reward Applied",
                      "redemption-591940-displayname": "$10.00 Off",
                      "redemption-591940-settings-button-color": "#0F8383",
                      "redemption-591940-settings-button-text": "Redeem",
                      "redemption-591940-settings-button-text-color": "#FFFFFF",
                      "redemption-591940-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591940-settings-call-to-action-button-text": "Redeem",
                      "redemption-591940-settings-cost": 1000,
                      "redemption-591940-settings-cost-color": "#6C6C6C",
                      "redemption-591940-settings-cost-font-size": "16",
                      "redemption-591940-settings-cost-text": "{{points}} points",
                      "redemption-591940-settings-coupon-cost-font-size": "15",
                      "redemption-591940-settings-coupon-reward-font-size": "20",
                      "redemption-591940-settings-discount-amount-cents": 1000,
                      "redemption-591940-settings-discount-type": "fixed_amount",
                      "redemption-591940-settings-reward": "$10.00 Off",
                      "redemption-591940-settings-reward-color": "#000000",
                      "redemption-591940-settings-reward-font-size": "20",
                      "redemption-591940-settings-success-message-text": "Reward Applied",
                      "redemption-591941-displayname": "$20.00 Off",
                      "redemption-591941-settings-button-color": "#0F8383",
                      "redemption-591941-settings-button-text": "Redeem",
                      "redemption-591941-settings-button-text-color": "#FFFFFF",
                      "redemption-591941-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591941-settings-call-to-action-button-text": "Redeem",
                      "redemption-591941-settings-cost": 2000,
                      "redemption-591941-settings-cost-color": "#6C6C6C",
                      "redemption-591941-settings-cost-font-size": "16",
                      "redemption-591941-settings-cost-text": "{{points}} points",
                      "redemption-591941-settings-coupon-cost-font-size": "15",
                      "redemption-591941-settings-coupon-reward-font-size": "20",
                      "redemption-591941-settings-discount-amount-cents": 2000,
                      "redemption-591941-settings-discount-type": "fixed_amount",
                      "redemption-591941-settings-reward": "$20.00 Off",
                      "redemption-591941-settings-reward-color": "#000000",
                      "redemption-591941-settings-reward-font-size": "20",
                      "redemption-591941-settings-success-message-text": "Reward Applied",
                      "redemption-743110-displayname": "$50 off",
                      "redemption-743110-settings-button-color": "#0F8383",
                      "redemption-743110-settings-button-text": "Redeem",
                      "redemption-743110-settings-button-text-color": "#FFFFFF",
                      "redemption-743110-settings-button-type": "rounded_filled_rectangle",
                      "redemption-743110-settings-call-to-action-button-text": "Redeem",
                      "redemption-743110-settings-cost": 5000,
                      "redemption-743110-settings-cost-color": "#6C6C6C",
                      "redemption-743110-settings-cost-font-size": "16",
                      "redemption-743110-settings-cost-text": "{{points}} points",
                      "redemption-743110-settings-coupon-cost-font-size": "15",
                      "redemption-743110-settings-coupon-reward-font-size": "20",
                      "redemption-743110-settings-discount-amount-cents": 5000,
                      "redemption-743110-settings-discount-type": "cart_fixed_amount",
                      "redemption-743110-settings-reward": "$50 off",
                      "redemption-743110-settings-reward-color": "#000000",
                      "redemption-743110-settings-reward-font-size": "20",
                      "redemption-743110-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://fonts.googleapis.com/css?family=Poppins:400\u0026display=swap",
                      "selected-extensions": [
                        "591939",
                        "591940",
                        "591941",
                        "743110"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": false,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "728217": {
                    instanceId: "728217",
                    instanceVersionId: "257130171",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-customer-preview/app.v0.2.8-6189.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "view-background-color": "transparent",
                      "view-primary-color": "#2e4f7c",
                      "view-primary-font": "Nunito Sans@700|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/nunito_sans/v1/nunito_sans_700.css",
                      "view-text-color": "#202020",
                      "welcome-text": "Good morning"
                    },
                    staticContent: {
                      "currency": "USD",
                      "hideIfMatchingQueryParam": [
                        "oseid"
                      ],
                      "isHidden": true,
                      "platformName": "shopify",
                      "selfExecutable": true,
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "https://georgestonecrab.com/account/login",
                      "storeRegistrationUrl": "https://georgestonecrab.com/account/register",
                      "storeRewardsPageUrl": "https://georgestonecrab.com/pages/rewards",
                      "urlMatch": "^(?!.*\\.yotpo\\.com).*$"
                    },
                    className: "CustomerPreview",
                    dependencyGroupId: null
                },
            
                "624108": {
                    instanceId: "624108",
                    instanceVersionId: "491228329",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.20-48.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-background-color": "#F6F1EE",
                      "logged-in-description-color": "#0F8383",
                      "logged-in-description-font-size": "22",
                      "logged-in-description-text": "{{current_point_balance}} points",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "#000000",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How it Works",
                      "primary-button-background-color": "#000000",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "rounded_filled_rectangle",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nearn 100 points.",
                      "reward-step-1-settings-description-color": "#6C6C6C",
                      "reward-step-1-settings-description-font-size": "16",
                      "reward-step-1-settings-icon": "default",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-title": "Sign up",
                      "reward-step-1-settings-title-color": "#000000",
                      "reward-step-1-settings-title-font-size": "20",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "#6C6C6C",
                      "reward-step-2-settings-description-font-size": "16",
                      "reward-step-2-settings-icon": "default",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-title": "Earn points",
                      "reward-step-2-settings-title-color": "#000000",
                      "reward-step-2-settings-title-font-size": "20",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive rewards.",
                      "reward-step-3-settings-description-color": "#6C6C6C",
                      "reward-step-3-settings-description-font-size": "16",
                      "reward-step-3-settings-icon": "default",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-title": "Redeem points",
                      "reward-step-3-settings-title-color": "#000000",
                      "reward-step-3-settings-title-font-size": "20",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(0,0,0,0.79)",
                      "rewards-history-headline-color": "#000000",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "#000000",
                      "secondary-button-text-color": "#000000",
                      "secondary-button-type": "rounded_rectangle",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "#0F8383",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "isVipTiersEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "624107": {
                    instanceId: "624107",
                    instanceVersionId: "487844469",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.31-119.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.",
                      "coupons-redemption-headline": "How to Use Your Points",
                      "coupons-redemption-rule": "100 points equals $1",
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "login-button-color": "#0F8383",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "rounded_filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#000000",
                      "points-balance-font-size": "16",
                      "points-balance-number-color": "#0F8383",
                      "primary-font-name-and-url": "Poppins@600|https://fonts.googleapis.com/css?family=Poppins:600\u0026display=swap",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-591939-displayname": "$5.00 Off",
                      "redemption-591939-settings-button-color": "#0F8383",
                      "redemption-591939-settings-button-text": "Redeem",
                      "redemption-591939-settings-button-text-color": "#FFFFFF",
                      "redemption-591939-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591939-settings-call-to-action-button-text": "Redeem",
                      "redemption-591939-settings-cost": 500,
                      "redemption-591939-settings-cost-color": "#6C6C6C",
                      "redemption-591939-settings-cost-font-size": "16",
                      "redemption-591939-settings-cost-text": "{{points}} points",
                      "redemption-591939-settings-coupon-cost-font-size": "15",
                      "redemption-591939-settings-coupon-reward-font-size": "20",
                      "redemption-591939-settings-discount-amount-cents": 500,
                      "redemption-591939-settings-discount-type": "fixed_amount",
                      "redemption-591939-settings-reward": "$5.00 Off",
                      "redemption-591939-settings-reward-color": "#000000",
                      "redemption-591939-settings-reward-font-size": "20",
                      "redemption-591939-settings-success-message-text": "Reward Applied",
                      "redemption-591940-displayname": "$10.00 Off",
                      "redemption-591940-settings-button-color": "#0F8383",
                      "redemption-591940-settings-button-text": "Redeem",
                      "redemption-591940-settings-button-text-color": "#FFFFFF",
                      "redemption-591940-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591940-settings-call-to-action-button-text": "Redeem",
                      "redemption-591940-settings-cost": 1000,
                      "redemption-591940-settings-cost-color": "#6C6C6C",
                      "redemption-591940-settings-cost-font-size": "16",
                      "redemption-591940-settings-cost-text": "{{points}} points",
                      "redemption-591940-settings-coupon-cost-font-size": "15",
                      "redemption-591940-settings-coupon-reward-font-size": "20",
                      "redemption-591940-settings-discount-amount-cents": 1000,
                      "redemption-591940-settings-discount-type": "fixed_amount",
                      "redemption-591940-settings-reward": "$10.00 Off",
                      "redemption-591940-settings-reward-color": "#000000",
                      "redemption-591940-settings-reward-font-size": "20",
                      "redemption-591940-settings-success-message-text": "Reward Applied",
                      "redemption-591941-displayname": "$20.00 Off",
                      "redemption-591941-settings-button-color": "#0F8383",
                      "redemption-591941-settings-button-text": "Redeem",
                      "redemption-591941-settings-button-text-color": "#FFFFFF",
                      "redemption-591941-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591941-settings-call-to-action-button-text": "Redeem",
                      "redemption-591941-settings-cost": 2000,
                      "redemption-591941-settings-cost-color": "#6C6C6C",
                      "redemption-591941-settings-cost-font-size": "16",
                      "redemption-591941-settings-cost-text": "{{points}} points",
                      "redemption-591941-settings-coupon-cost-font-size": "15",
                      "redemption-591941-settings-coupon-reward-font-size": "20",
                      "redemption-591941-settings-discount-amount-cents": 2000,
                      "redemption-591941-settings-discount-type": "fixed_amount",
                      "redemption-591941-settings-reward": "$20.00 Off",
                      "redemption-591941-settings-reward-color": "#000000",
                      "redemption-591941-settings-reward-font-size": "20",
                      "redemption-591941-settings-success-message-text": "Reward Applied",
                      "redemption-591986-displayname": "GIVE $25, GET $25",
                      "redemption-591986-settings-button-color": "#0F8383",
                      "redemption-591986-settings-button-text": "Redeem",
                      "redemption-591986-settings-button-text-color": "#FFFFFF",
                      "redemption-591986-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591986-settings-call-to-action-button-text": "Redeem",
                      "redemption-591986-settings-cost": 0,
                      "redemption-591986-settings-cost-color": "#6C6C6C",
                      "redemption-591986-settings-cost-font-size": "16",
                      "redemption-591986-settings-cost-text": "{{points}} points",
                      "redemption-591986-settings-coupon-cost-font-size": "15",
                      "redemption-591986-settings-coupon-reward-font-size": "20",
                      "redemption-591986-settings-discount-amount-cents": 2500,
                      "redemption-591986-settings-discount-type": "fixed_amount",
                      "redemption-591986-settings-reward": "GIVE $25, GET $25",
                      "redemption-591986-settings-reward-color": "#000000",
                      "redemption-591986-settings-reward-font-size": "20",
                      "redemption-591986-settings-success-message-text": "Reward Applied",
                      "redemption-743110-displayname": "$50 off",
                      "redemption-743110-settings-button-color": "#0F8383",
                      "redemption-743110-settings-button-text": "Redeem",
                      "redemption-743110-settings-button-text-color": "#FFFFFF",
                      "redemption-743110-settings-button-type": "rounded_filled_rectangle",
                      "redemption-743110-settings-call-to-action-button-text": "Redeem",
                      "redemption-743110-settings-cost": 5000,
                      "redemption-743110-settings-cost-color": "#6C6C6C",
                      "redemption-743110-settings-cost-font-size": "16",
                      "redemption-743110-settings-cost-text": "{{points}} points",
                      "redemption-743110-settings-coupon-cost-font-size": "15",
                      "redemption-743110-settings-coupon-reward-font-size": "20",
                      "redemption-743110-settings-discount-amount-cents": 5000,
                      "redemption-743110-settings-discount-type": "cart_fixed_amount",
                      "redemption-743110-settings-reward": "$50 off",
                      "redemption-743110-settings-reward-color": "#000000",
                      "redemption-743110-settings-reward-font-size": "20",
                      "redemption-743110-settings-success-message-text": "Reward Applied",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://fonts.googleapis.com/css?family=Poppins:400\u0026display=swap",
                      "selected-extensions": [
                        "591939",
                        "591940",
                        "591941",
                        "591986",
                        "743110"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "624106": {
                    instanceId: "624106",
                    instanceVersionId: "483853198",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.7-18.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "624105": {
                    instanceId: "624105",
                    instanceVersionId: "498707018",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.18-51.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1010821-background-color": "transparent",
                      "campaign-item-1010821-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010821-background-type": "color",
                      "campaign-item-1010821-border-color": "#BCBCBC",
                      "campaign-item-1010821-description-font-color": "#6c6c6c",
                      "campaign-item-1010821-description-font-size": "16",
                      "campaign-item-1010821-exclude_audience_ids": null,
                      "campaign-item-1010821-exclude_audience_names": [],
                      "campaign-item-1010821-hover-view-tile-message": "Earn 120 points when you create an account",
                      "campaign-item-1010821-icon-color": "#60a3a3",
                      "campaign-item-1010821-icon-type": "defaultIcon",
                      "campaign-item-1010821-include_audience_ids": "1",
                      "campaign-item-1010821-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010821-special-reward-enabled": "false",
                      "campaign-item-1010821-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010821-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010821-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010821-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010821-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010821-tile-description": "Create an account",
                      "campaign-item-1010821-tile-reward": "120 Points",
                      "campaign-item-1010821-title-font-color": "#000000",
                      "campaign-item-1010821-title-font-size": "18",
                      "campaign-item-1010821-type": "CreateAccountCampaign",
                      "campaign-item-1010822-action-tile-ask-year": "true",
                      "campaign-item-1010822-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-1010822-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1010822-action-tile-european-date-format": "false",
                      "campaign-item-1010822-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1010822-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1010822-action-tile-title": "Earn 140 points on your birthday",
                      "campaign-item-1010822-background-color": "transparent",
                      "campaign-item-1010822-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010822-background-type": "color",
                      "campaign-item-1010822-border-color": "#BCBCBC",
                      "campaign-item-1010822-description-font-color": "#6c6c6c",
                      "campaign-item-1010822-description-font-size": "16",
                      "campaign-item-1010822-exclude_audience_ids": null,
                      "campaign-item-1010822-exclude_audience_names": [],
                      "campaign-item-1010822-icon-color": "#60a3a3",
                      "campaign-item-1010822-icon-type": "defaultIcon",
                      "campaign-item-1010822-include_audience_ids": "1",
                      "campaign-item-1010822-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010822-special-reward-enabled": "false",
                      "campaign-item-1010822-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010822-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010822-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010822-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010822-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010822-tile-description": "Happy Birthday!",
                      "campaign-item-1010822-tile-reward": "140 Points",
                      "campaign-item-1010822-title-font-color": "#000000",
                      "campaign-item-1010822-title-font-size": "18",
                      "campaign-item-1010822-type": "BirthdayCampaign",
                      "campaign-item-1010823-background-color": "transparent",
                      "campaign-item-1010823-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010823-background-type": "color",
                      "campaign-item-1010823-border-color": "#BCBCBC",
                      "campaign-item-1010823-description-font-color": "#6c6c6c",
                      "campaign-item-1010823-description-font-size": "16",
                      "campaign-item-1010823-exclude_audience_ids": null,
                      "campaign-item-1010823-exclude_audience_names": [],
                      "campaign-item-1010823-hover-view-tile-message": "Earn 1 points for every $1.00 you spend in our store",
                      "campaign-item-1010823-icon-color": "#60a3a3",
                      "campaign-item-1010823-icon-type": "defaultIcon",
                      "campaign-item-1010823-include_audience_ids": "1",
                      "campaign-item-1010823-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010823-special-reward-enabled": "false",
                      "campaign-item-1010823-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010823-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010823-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010823-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010823-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010823-tile-description": "Make a purchase",
                      "campaign-item-1010823-tile-reward": "1 Points Per $1.00",
                      "campaign-item-1010823-title-font-color": "#000000",
                      "campaign-item-1010823-title-font-size": "18",
                      "campaign-item-1010823-type": "PointsForPurchasesCampaign",
                      "campaign-item-1010839-action-tile-action-text": "Share on Facebook",
                      "campaign-item-1010839-action-tile-title": "Earn 40 points when you share us on Facebook",
                      "campaign-item-1010839-background-color": "transparent",
                      "campaign-item-1010839-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010839-background-type": "color",
                      "campaign-item-1010839-border-color": "#BCBCBC",
                      "campaign-item-1010839-description-font-color": "#6c6c6c",
                      "campaign-item-1010839-description-font-size": "16",
                      "campaign-item-1010839-exclude_audience_ids": null,
                      "campaign-item-1010839-exclude_audience_names": [],
                      "campaign-item-1010839-icon-color": "#60a3a3",
                      "campaign-item-1010839-icon-type": "defaultIcon",
                      "campaign-item-1010839-include_audience_ids": "1",
                      "campaign-item-1010839-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010839-special-reward-enabled": "false",
                      "campaign-item-1010839-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010839-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010839-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010839-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010839-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010839-tile-description": "Share On Facebook",
                      "campaign-item-1010839-tile-reward": "40 Points",
                      "campaign-item-1010839-title-font-color": "#000000",
                      "campaign-item-1010839-title-font-size": "18",
                      "campaign-item-1010839-type": "FacebookShareCampaign",
                      "campaign-item-1010840-background-color": "transparent",
                      "campaign-item-1010840-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010840-background-type": "color",
                      "campaign-item-1010840-border-color": "#BCBCBC",
                      "campaign-item-1010840-description-font-color": "#6c6c6c",
                      "campaign-item-1010840-description-font-size": "16",
                      "campaign-item-1010840-exclude_audience_ids": null,
                      "campaign-item-1010840-exclude_audience_names": [],
                      "campaign-item-1010840-hover-view-tile-message": "Earn 100 points for leaving a review",
                      "campaign-item-1010840-icon-color": "#60a3a3",
                      "campaign-item-1010840-icon-type": "defaultIcon",
                      "campaign-item-1010840-include_audience_ids": "1",
                      "campaign-item-1010840-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1010840-special-reward-enabled": "false",
                      "campaign-item-1010840-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1010840-special-reward-headline-text": "Just for you!",
                      "campaign-item-1010840-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1010840-special-reward-headline-title-font-size": "12",
                      "campaign-item-1010840-special-reward-tile-border-color": "#000000",
                      "campaign-item-1010840-tile-description": "Leave a Review",
                      "campaign-item-1010840-tile-reward": "100 points",
                      "campaign-item-1010840-title-font-color": "#000000",
                      "campaign-item-1010840-title-font-size": "18",
                      "campaign-item-1010840-type": "YotpoReviewCampaign",
                      "campaign-item-1014496-action-tile-action-text": "Follow Us",
                      "campaign-item-1014496-action-tile-title": "Earn 100 points when you follow us on Instagram",
                      "campaign-item-1014496-background-color": "transparent",
                      "campaign-item-1014496-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014496-background-type": "color",
                      "campaign-item-1014496-border-color": "#BCBCBC",
                      "campaign-item-1014496-description-font-color": "#6c6c6c",
                      "campaign-item-1014496-description-font-size": "16",
                      "campaign-item-1014496-exclude_audience_ids": null,
                      "campaign-item-1014496-exclude_audience_names": [],
                      "campaign-item-1014496-icon-color": "#60a3a3",
                      "campaign-item-1014496-icon-type": "defaultIcon",
                      "campaign-item-1014496-include_audience_ids": "1",
                      "campaign-item-1014496-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1014496-special-reward-enabled": "false",
                      "campaign-item-1014496-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1014496-special-reward-headline-text": "Just for you!",
                      "campaign-item-1014496-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1014496-special-reward-headline-title-font-size": "12",
                      "campaign-item-1014496-special-reward-tile-border-color": "#000000",
                      "campaign-item-1014496-tile-description": "Follow us on Instagram",
                      "campaign-item-1014496-tile-reward": "100 Points",
                      "campaign-item-1014496-title-font-color": "#000000",
                      "campaign-item-1014496-title-font-size": "18",
                      "campaign-item-1014496-type": "InstagramFollowCampaign",
                      "campaign-item-1014517-background-color": "transparent",
                      "campaign-item-1014517-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014517-background-type": "color",
                      "campaign-item-1014517-border-color": "#BCBCBC",
                      "campaign-item-1014517-description-font-color": "#6c6c6c",
                      "campaign-item-1014517-description-font-size": "16",
                      "campaign-item-1014517-exclude_audience_ids": null,
                      "campaign-item-1014517-exclude_audience_names": [],
                      "campaign-item-1014517-hover-view-tile-message": "Earn 400 points when you make 5 purchases",
                      "campaign-item-1014517-icon-color": "#60a3a3",
                      "campaign-item-1014517-icon-type": "defaultIcon",
                      "campaign-item-1014517-include_audience_ids": "1",
                      "campaign-item-1014517-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1014517-special-reward-enabled": "false",
                      "campaign-item-1014517-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1014517-special-reward-headline-text": "Just for you!",
                      "campaign-item-1014517-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1014517-special-reward-headline-title-font-size": "12",
                      "campaign-item-1014517-special-reward-tile-border-color": "#000000",
                      "campaign-item-1014517-tile-description": "Make 5 Purchases",
                      "campaign-item-1014517-tile-reward": "400 Points",
                      "campaign-item-1014517-title-font-color": "#000000",
                      "campaign-item-1014517-title-font-size": "18",
                      "campaign-item-1014517-type": "TransactionBasedCampaign",
                      "campaign-item-1014518-action-tile-anniversary-required-field-message": "This field is required",
                      "campaign-item-1014518-action-tile-ask-year": "false",
                      "campaign-item-1014518-action-tile-european-date-format": "false",
                      "campaign-item-1014518-action-tile-final-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1014518-action-tile-message-text": "If your anniversary is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1014518-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1014518-action-tile-title": "Earn 140 points on your anniversary",
                      "campaign-item-1014518-background-color": "transparent",
                      "campaign-item-1014518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014518-background-type": "color",
                      "campaign-item-1014518-border-color": "#BCBCBC",
                      "campaign-item-1014518-description-font-color": "#6c6c6c",
                      "campaign-item-1014518-description-font-size": "16",
                      "campaign-item-1014518-exclude_audience_ids": null,
                      "campaign-item-1014518-exclude_audience_names": [],
                      "campaign-item-1014518-icon-color": "#60a3a3",
                      "campaign-item-1014518-icon-type": "defaultIcon",
                      "campaign-item-1014518-include_audience_ids": "1",
                      "campaign-item-1014518-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1014518-special-reward-enabled": "false",
                      "campaign-item-1014518-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1014518-special-reward-headline-text": "Just for you!",
                      "campaign-item-1014518-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1014518-special-reward-headline-title-font-size": "12",
                      "campaign-item-1014518-special-reward-tile-border-color": "#000000",
                      "campaign-item-1014518-tile-description": "Happy Anniversary",
                      "campaign-item-1014518-tile-reward": "140 Points",
                      "campaign-item-1014518-title-font-color": "#000000",
                      "campaign-item-1014518-title-font-size": "18",
                      "campaign-item-1014518-type": "AnniversaryCampaign",
                      "campaign-item-1053255-action-tile-action-text": "Click Here",
                      "campaign-item-1053255-action-tile-title": "Earn 20 points when you share us on Facebook",
                      "campaign-item-1053255-background-color": "transparent",
                      "campaign-item-1053255-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1053255-background-type": "color",
                      "campaign-item-1053255-border-color": "#BCBCBC",
                      "campaign-item-1053255-description-font-color": "#6c6c6c",
                      "campaign-item-1053255-description-font-size": "16",
                      "campaign-item-1053255-exclude_audience_ids": null,
                      "campaign-item-1053255-exclude_audience_names": [],
                      "campaign-item-1053255-icon-color": "#60a3a3",
                      "campaign-item-1053255-icon-type": "defaultIcon",
                      "campaign-item-1053255-include_audience_ids": "1",
                      "campaign-item-1053255-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1053255-special-reward-enabled": "false",
                      "campaign-item-1053255-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1053255-special-reward-headline-text": "Just for you!",
                      "campaign-item-1053255-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1053255-special-reward-headline-title-font-size": "12",
                      "campaign-item-1053255-special-reward-tile-border-color": "#000000",
                      "campaign-item-1053255-tile-description": "Like on Facebook",
                      "campaign-item-1053255-tile-reward": "20 Points",
                      "campaign-item-1053255-title-font-color": "#000000",
                      "campaign-item-1053255-title-font-size": "18",
                      "campaign-item-1053255-type": "CustomActionCampaign",
                      "campaign-item-1053255-view-show-custom-action-button": "false",
                      "campaign-item-1156384-background-color": "transparent",
                      "campaign-item-1156384-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1156384-background-type": "color",
                      "campaign-item-1156384-border-color": "#BCBCBC",
                      "campaign-item-1156384-description-font-color": "#6c6c6c",
                      "campaign-item-1156384-description-font-size": "16",
                      "campaign-item-1156384-exclude_audience_ids": null,
                      "campaign-item-1156384-exclude_audience_names": [],
                      "campaign-item-1156384-hover-view-tile-message": "Earn 3 point for every $1 you spend in our store during Father's Day Week!",
                      "campaign-item-1156384-icon-color": "#60a3a3",
                      "campaign-item-1156384-icon-type": "defaultIcon",
                      "campaign-item-1156384-include_audience_ids": "1",
                      "campaign-item-1156384-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1156384-special-reward-enabled": "false",
                      "campaign-item-1156384-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1156384-special-reward-headline-text": "Just for you!",
                      "campaign-item-1156384-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1156384-special-reward-headline-title-font-size": "12",
                      "campaign-item-1156384-special-reward-tile-border-color": "#000000",
                      "campaign-item-1156384-tile-description": "Father's Day Week 3x",
                      "campaign-item-1156384-tile-reward": "Three Point Per Dollar Spent",
                      "campaign-item-1156384-title-font-color": "#000000",
                      "campaign-item-1156384-title-font-size": "18",
                      "campaign-item-1156384-type": "PointsForPurchasesCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "#000000",
                      "general-hover-tile-button-text-color": "#FFFFFF",
                      "general-hover-tile-button-type": "rounded_filled_rectangle",
                      "general-hover-tile-color-overlay": "#D2E3E3",
                      "general-hover-tile-text-color": "#000000",
                      "headline-font-color": "#000000",
                      "headline-font-size": "26px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "secondary-text-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1053255",
                        "1010822",
                        "1010821",
                        "1010823",
                        "1010839",
                        "1010840",
                        "1014496",
                        "1014517",
                        "1014518",
                        "1156384"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "isSegmentationsPickerEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//georgestonecrab.com/account/login",
                      "storeAccountRegistrationUrl": "//georgestonecrab.com/account/register",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "624104": {
                    instanceId: "624104",
                    instanceVersionId: "483815713",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v2.5.20-15.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#F6F1EE",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2024_02_12_20_55_19_614",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $25 off on their first order of $100+ and get $25 in points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $25, GET $25",
                      "customer-name-view-input-placeholder": "Your first name",
                      "default-toggle": true,
                      "description-color": "rgba(13,59,112,1)",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Montserrat@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/montserrat/v1/montserrat_600.css",
                      "fonts-secondary-font-name-and-url": "Montserrat@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/montserrat/v1/montserrat_400.css",
                      "header-color": "rgba(13,59,112,1)",
                      "header-font-size": "18px",
                      "headline-color": "rgba(13,59,112,1)",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba(13,59,112,1)",
                      "next-button-font-size": "16px",
                      "next-button-size": "standard",
                      "next-button-text-color": "rgba(13,59,112,1)",
                      "next-button-type": "rectangular_outline",
                      "primary-font-name-and-url": "Montserrat@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/montserrat/v1/montserrat_600.css",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description": "Give your friends $25 off on their first order of $100+ and get $25 in points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title": "GIVE $25, GET $25",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-font-name-and-url": "Montserrat@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/montserrat/v1/montserrat_400.css",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Get a discount and shop today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop using my link to get a discount {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "#F6F1EE",
                      "title-color": "rgba(13,59,112,1)",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "left",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": true,
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "624103": {
                    instanceId: "624103",
                    instanceVersionId: "484924713",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.8.5-42.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/widget-hero-section/customizations/defaults/background-image.jpg",
                      "description-color": "#000000",
                      "description-font-size": "16",
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "#000000",
                      "login-button-text": "LOG IN",
                      "login-button-text-color": "#000000",
                      "login-button-type": "rounded_rectangle",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/widget-hero-section/customizations/defaults/background-image-mobile.png",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "register-button-color": "#000000",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "#ffffff",
                      "register-button-type": "rounded_filled_rectangle",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": "true",
                      "text-background-show-on-mobile": "true",
                      "view-layout": "left-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "//georgestonecrab.com/account/login",
                      "storeRegistrationUrl": "//georgestonecrab.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "71867": {
                    instanceId: "71867",
                    instanceVersionId: "326330748",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v0.6.1-4815.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#666d8b",
                      "description-font-size": "20",
                      "headline-color": "#011247",
                      "headline-font-size": "36",
                      "layout-background-color": "white",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "500 points",
                      "redemption-1-settings-cost-color": "#666d8b",
                      "redemption-1-settings-cost-font-size": "20",
                      "redemption-1-settings-reward": "$5",
                      "redemption-1-settings-reward-color": "#011247",
                      "redemption-1-settings-reward-font-size": "30",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "1000 points",
                      "redemption-2-settings-cost-color": "#666d8b",
                      "redemption-2-settings-cost-font-size": "20",
                      "redemption-2-settings-reward": "$10",
                      "redemption-2-settings-reward-color": "#011247",
                      "redemption-2-settings-reward-font-size": "30",
                      "redemption-233955-displayname": "Tile 4 (233955)",
                      "redemption-233955-settings-cost": "5000 points",
                      "redemption-233955-settings-cost-color": "#666d8b",
                      "redemption-233955-settings-cost-font-size": "20",
                      "redemption-233955-settings-reward": "$50",
                      "redemption-233955-settings-reward-color": "#011247",
                      "redemption-233955-settings-reward-font-size": "30",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "2000 points",
                      "redemption-3-settings-cost-color": "#666d8b",
                      "redemption-3-settings-cost-font-size": "20",
                      "redemption-3-settings-reward": "$20",
                      "redemption-3-settings-reward-color": "#011247",
                      "redemption-3-settings-reward-font-size": "30",
                      "rule-border-color": "#bccdfe",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3",
                        "233955"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your hard-earned points is easy! Simply apply your points for a discount at checkout!",
                      "visual-redemption-headline": "How to use your points",
                      "visual-redemption-rule": "100 points equals $1.00"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "71866": {
                    instanceId: "71866",
                    instanceVersionId: "468266341",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-loyalty-campaigns/app.v0.7.0-2646.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/t8qnZXgIaD5VegJXul3Q5A/css-overrides/css-overrides.2021_11_17_10_37_05_230.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#4e5772",
                      "campaign-description-size": "18px",
                      "campaign-item-050135-action-tile-action-text": "Click here",
                      "campaign-item-050135-action-tile-title": "Earn points for an action",
                      "campaign-item-050135-background-color": "#f9faff",
                      "campaign-item-050135-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-050135-background-type": "color",
                      "campaign-item-050135-border-color": "#848ca3",
                      "campaign-item-050135-description-font-color": "#4e5772",
                      "campaign-item-050135-description-font-size": "18",
                      "campaign-item-050135-displayname": "Like On Facebook (050135)",
                      "campaign-item-050135-icon-color": "#768cdc",
                      "campaign-item-050135-icon-type": "customIcon",
                      "campaign-item-050135-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_05_17_813",
                      "campaign-item-050135-tile-description": "Like on Facebook",
                      "campaign-item-050135-tile-reward": "20 points",
                      "campaign-item-050135-title-font-color": "#011247",
                      "campaign-item-050135-title-font-size": "27",
                      "campaign-item-050135-type": "FreeTextCampaign",
                      "campaign-item-050135-view-show-custom-action-button": "false",
                      "campaign-item-1010821-background-color": "#f9faff",
                      "campaign-item-1010821-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010821-background-type": "color",
                      "campaign-item-1010821-border-color": "#848ca3",
                      "campaign-item-1010821-description-font-color": "#4e5772",
                      "campaign-item-1010821-description-font-size": "18",
                      "campaign-item-1010821-hover-view-tile-message": "Earn 120 points when you create an account",
                      "campaign-item-1010821-icon-color": "#768cdc",
                      "campaign-item-1010821-icon-type": "customIcon",
                      "campaign-item-1010821-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_06_49_282",
                      "campaign-item-1010821-tile-description": "Create an account",
                      "campaign-item-1010821-tile-reward": "120 Points",
                      "campaign-item-1010821-title-font-color": "#011247",
                      "campaign-item-1010821-title-font-size": "27",
                      "campaign-item-1010821-type": "CreateAccountCampaign",
                      "campaign-item-1010822-action-tile-action-text": "Add My Birthday",
                      "campaign-item-1010822-action-tile-birthday-ask-year": "false",
                      "campaign-item-1010822-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1010822-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1010822-action-tile-title": "Earn 140 points on your birthday",
                      "campaign-item-1010822-background-color": "#f9faff",
                      "campaign-item-1010822-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010822-background-type": "color",
                      "campaign-item-1010822-border-color": "#848ca3",
                      "campaign-item-1010822-description-font-color": "#4e5772",
                      "campaign-item-1010822-description-font-size": "18",
                      "campaign-item-1010822-icon-color": "#768cdc",
                      "campaign-item-1010822-icon-type": "customIcon",
                      "campaign-item-1010822-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_08_07_959",
                      "campaign-item-1010822-tile-description": "Happy Birthday!",
                      "campaign-item-1010822-tile-reward": "140 Points",
                      "campaign-item-1010822-title-font-color": "#011247",
                      "campaign-item-1010822-title-font-size": "27",
                      "campaign-item-1010822-type": "BirthdayCampaign",
                      "campaign-item-1010823-background-color": "#f9faff",
                      "campaign-item-1010823-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010823-background-type": "color",
                      "campaign-item-1010823-border-color": "#848ca3",
                      "campaign-item-1010823-description-font-color": "#4e5772",
                      "campaign-item-1010823-description-font-size": "18",
                      "campaign-item-1010823-hover-view-tile-message": "Earn 1 points for every $1.00 you spend in our store",
                      "campaign-item-1010823-icon-color": "#768cdc",
                      "campaign-item-1010823-icon-type": "customIcon",
                      "campaign-item-1010823-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_07_48_664",
                      "campaign-item-1010823-tile-description": "Make a purchase",
                      "campaign-item-1010823-tile-reward": "1 Points Per $1.00",
                      "campaign-item-1010823-title-font-color": "#011247",
                      "campaign-item-1010823-title-font-size": "27",
                      "campaign-item-1010823-type": "PointsForPurchasesCampaign",
                      "campaign-item-1010839-action-tile-action-text": "Share on Facebook",
                      "campaign-item-1010839-action-tile-title": "Earn 40 points when you share us on Facebook",
                      "campaign-item-1010839-background-color": "#f9faff",
                      "campaign-item-1010839-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010839-background-type": "color",
                      "campaign-item-1010839-border-color": "#848ca3",
                      "campaign-item-1010839-description-font-color": "#4e5772",
                      "campaign-item-1010839-description-font-size": "18",
                      "campaign-item-1010839-icon-color": "#768cdc",
                      "campaign-item-1010839-icon-type": "customIcon",
                      "campaign-item-1010839-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_06_07_444",
                      "campaign-item-1010839-tile-description": "Share On Facebook",
                      "campaign-item-1010839-tile-reward": "40 points",
                      "campaign-item-1010839-title-font-color": "#011247",
                      "campaign-item-1010839-title-font-size": "27",
                      "campaign-item-1010839-type": "FacebookShareCampaign",
                      "campaign-item-1010840-background-color": "#f9faff",
                      "campaign-item-1010840-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1010840-background-type": "color",
                      "campaign-item-1010840-border-color": "#848ca3",
                      "campaign-item-1010840-description-font-color": "#4e5772",
                      "campaign-item-1010840-description-font-size": "18",
                      "campaign-item-1010840-hover-view-tile-message": "Earn 100 points for leaving a review",
                      "campaign-item-1010840-icon-color": "#768cdc",
                      "campaign-item-1010840-icon-type": "customIcon",
                      "campaign-item-1010840-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_06_34_293",
                      "campaign-item-1010840-tile-description": "Leave a Review",
                      "campaign-item-1010840-tile-reward": "100 points",
                      "campaign-item-1010840-title-font-color": "#011247",
                      "campaign-item-1010840-title-font-size": "27",
                      "campaign-item-1010840-type": "YotpoReviewCampaign",
                      "campaign-item-1014496-action-tile-action-text": "Follow Us",
                      "campaign-item-1014496-action-tile-title": "Earn 100 points when you follow us on Instagram",
                      "campaign-item-1014496-background-color": "#f9faff",
                      "campaign-item-1014496-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014496-background-type": "color",
                      "campaign-item-1014496-border-color": "#848ca3",
                      "campaign-item-1014496-description-font-color": "#4e5772",
                      "campaign-item-1014496-description-font-size": "18",
                      "campaign-item-1014496-icon-color": "#768cdc",
                      "campaign-item-1014496-icon-type": "customIcon",
                      "campaign-item-1014496-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_07_01_702",
                      "campaign-item-1014496-tile-description": "Follow us on Instagram",
                      "campaign-item-1014496-tile-reward": "100 points",
                      "campaign-item-1014496-title-font-color": "#011247",
                      "campaign-item-1014496-title-font-size": "27",
                      "campaign-item-1014496-type": "InstagramFollowCampaign",
                      "campaign-item-1014518-action-tile-action-text": "Add My Anniversary",
                      "campaign-item-1014518-action-tile-final-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1014518-action-tile-message-text": "If your anniversary is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1014518-action-tile-title": "Earn 140 points on your anniversary",
                      "campaign-item-1014518-background-color": "#f9faff",
                      "campaign-item-1014518-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1014518-background-type": "color",
                      "campaign-item-1014518-border-color": "#848ca3",
                      "campaign-item-1014518-description-font-color": "#4e5772",
                      "campaign-item-1014518-description-font-size": "18",
                      "campaign-item-1014518-icon-color": "#768cdc",
                      "campaign-item-1014518-icon-type": "customIcon",
                      "campaign-item-1014518-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_10_04_863",
                      "campaign-item-1014518-tile-description": "Happy Anniversary",
                      "campaign-item-1014518-tile-reward": "140 Points",
                      "campaign-item-1014518-title-font-color": "#011247",
                      "campaign-item-1014518-title-font-size": "27",
                      "campaign-item-1014518-type": "AnniversaryCampaign",
                      "campaign-item-227931-action-tile-action-text": "Click here",
                      "campaign-item-227931-action-tile-title": "Earn points for an action",
                      "campaign-item-227931-background-color": "#f9faff",
                      "campaign-item-227931-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-227931-background-type": "color",
                      "campaign-item-227931-border-color": "#848ca3",
                      "campaign-item-227931-description-font-color": "#4e5772",
                      "campaign-item-227931-description-font-size": "18",
                      "campaign-item-227931-displayname": "Sign up for SMS (227931)",
                      "campaign-item-227931-icon-color": "#768cdc",
                      "campaign-item-227931-icon-type": "customIcon",
                      "campaign-item-227931-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_10_08_23_250",
                      "campaign-item-227931-tile-description": "Sign up for SMS",
                      "campaign-item-227931-tile-reward": "200 points",
                      "campaign-item-227931-title-font-color": "#011247",
                      "campaign-item-227931-title-font-size": "27",
                      "campaign-item-227931-type": "FreeTextCampaign",
                      "campaign-item-227931-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "#011247",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "Ways to Earn Points",
                      "general-hover-tile-button-color": "#ffffff",
                      "general-hover-tile-button-text-color": "rgba(2,40,74,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(2,40,74,1)",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "rgba(2,40,74,1)",
                      "headline-font-size": "36px",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-text-font-name-and-url": "Montserrat@400|https://fonts.googleapis.com/css?family=Montserrat\u0026display=swap",
                      "selected-extensions": [
                        "050135",
                        "1010839",
                        "1010840",
                        "1010821",
                        "1014496",
                        "1010823",
                        "1010822",
                        "227931",
                        "1014518"
                      ],
                      "tile-border-color": "#848ca3",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#f9faff",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//georgestonecrab.com/account/login",
                      "storeAccountRegistrationUrl": "//georgestonecrab.com/account/register",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "71865": {
                    instanceId: "71865",
                    instanceVersionId: "327687525",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-hero-section/app.v0.1.6-2637.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/t8qnZXgIaD5VegJXul3Q5A/css-overrides/css-overrides.2021_11_17_10_38_30_501.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_49_33_311",
                      "description-color": "rgba(255,255,255,1)",
                      "description-font-size": "20",
                      "description-text-logged-in": "As a member you'll earn points \u0026 exclusive rewards every time you shop.",
                      "description-text-logged-out": "As a rewards member, you'll get closer to earning exclusive rewards every time you shop.",
                      "headline-color": "rgba(255,255,255,1)",
                      "headline-font-size": "40",
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-out": "Rewards",
                      "login-button-color": "rgba(255,255,255,1)",
                      "login-button-text": "LOGIN",
                      "login-button-text-color": "rgba(255,255,255,1)",
                      "login-button-type": "rectangular_outline",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_50_01_767",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "register-button-color": "rgba(255,255,255,1)",
                      "register-button-text": "JOIN NOW",
                      "register-button-text-color": "rgba(246,145,119,1)",
                      "register-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-layout": "right-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "//georgestonecrab.com/account/login",
                      "storeRegistrationUrl": "//georgestonecrab.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "71864": {
                    instanceId: "71864",
                    instanceVersionId: "24360303",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-widget/app.v1.8.1-4652.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba( 255, 255, 255, 1 )",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_57_17_569",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description": "Give your friends $25 off on their first order of $100+ and get $25 in points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title": "GIVE $25, GET $25",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba( 55, 51, 48, 1 )",
                      "description-font-size": "20px",
                      "final-view-button-text": "REFER MORE FRIENDS",
                      "final-view-description": "Remind your friends to check their emails",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "THANKS FOR REFERRING",
                      "fonts-primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "fonts-secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "header-color": "rgba( 0, 0, 0, 1 )",
                      "header-font-size": "18px",
                      "main-share-option-desktop": "main_share_email",
                      "main-share-option-mobile": "main_share_sms",
                      "next-button-background-color": "rgba( 118, 140,  220, 1 )",
                      "next-button-font-size": "18px",
                      "next-button-size": "standard",
                      "next-button-text-color": "rgba( 118, 140,  220, 1 )",
                      "next-button-type": "rectangular_outline",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "COMPLETED",
                      "referral-history-pending-status": "PENDING",
                      "referral-history-redeem-text": "To redeem your points, simply apply your discount at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Give your friends $20 off their first order of $40 and get $20 (in points) for each successful referral",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "GIVE $20, GET $20",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": true,
                      "share-allow-sms": true,
                      "share-allow-twitter": true,
                      "share-allow-whatsapp": true,
                      "share-facebook-header": "Earn A Discount When You Shop Today!",
                      "share-facebook-image-url": "",
                      "share-icons-color": "black",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-twitter-message": "These guys are great! Get a discount using my link: ",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "medium",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba( 255, 255, 255, 1 )",
                      "title-color": "rgba( 55, 51, 48, 1 )",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-popup-delay-ms": 0,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#558342",
                      "view-table-theme": "dark",
                      "view-table-type": "rectangular",
                      "wadmin-text-and-share-choose-sreen": "step_1"
                    },
                    staticContent: {
                      "companyName": "George Stone Crab",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
                "71863": {
                    instanceId: "71863",
                    instanceVersionId: "327687545",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-my-rewards/app.v0.1.10-2649.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/t8qnZXgIaD5VegJXul3Q5A/css-overrides/css-overrides.2021_11_17_10_32_39_413.css",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "rgba(255,255,255,1)",
                      "logged-in-description-font-size": "34",
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "rgba(255,255,255,1)",
                      "logged-in-headline-font-size": "36",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "REDEEM NOW",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "rgba(255,255,255,1)",
                      "logged-out-headline-font-size": "36",
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_3",
                      "primary-button-background-color": "rgba(246,145,119,1)",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Join the reel rewards\nprogram and start earning.",
                      "reward-step-1-settings-description-color": "rgba(255,255,255,1)",
                      "reward-step-1-settings-description-font-size": "20",
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_36_06_937",
                      "reward-step-1-settings-title": "JOIN",
                      "reward-step-1-settings-title-color": "rgba(255,255,255,1)",
                      "reward-step-1-settings-title-font-size": "24",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "rgba(255,255,255,1)",
                      "reward-step-2-settings-description-font-size": "20",
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "rgba(255,255,255,1)",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_37_54_754",
                      "reward-step-2-settings-title": "EARN POINTS",
                      "reward-step-2-settings-title-color": "rgba(255,255,255,1)",
                      "reward-step-2-settings-title-font-size": "24",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive discounts.",
                      "reward-step-3-settings-description-color": "rgba(255,255,255,1)",
                      "reward-step-3-settings-description-font-size": "20",
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "rgba(255,255,255,1)",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/t8qnZXgIaD5VegJXul3Q5A/images/image_2021_11_17_09_38_12_747",
                      "reward-step-3-settings-title": "REDEEM POINTS",
                      "reward-step-3-settings-title-color": "rgba(255,255,255,1)",
                      "reward-step-3-settings-title-font-size": "24",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "#10055c",
                      "rewards-history-headline-font-size": "28",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(246,145,119,1)",
                      "secondary-button-text-color": "rgba(246,145,119,1)",
                      "secondary-button-type": "rectangular_outline",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "view-grid-points-column-color": "#7a97e8",
                      "view-grid-rectangular-background-color": "#e6ecff",
                      "view-grid-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "71862": {
                    instanceId: "71862",
                    instanceVersionId: "437357320",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v0.6.2-5198.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "NO",
                      "confirmation-step-confirm-option": "YES",
                      "confirmation-step-title": "ARE YOU SURE?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout.",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "COPIED",
                      "coupons-redemption-description": "",
                      "coupons-redemption-headline": "How to use your points",
                      "coupons-redemption-rule": "1000 points equals $10.00",
                      "description-color": "rgba(44,44,44,1)",
                      "description-font-size": 20,
                      "disabled-outline-button-color": "#929292",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "DONATE",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "SUCCESS",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "rgba(1,18,71,1)",
                      "headline-font-size": "36",
                      "login-button-color": "rgba(246,145,119,1)",
                      "login-button-text": "REDEEM MY POINTS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "20",
                      "points-balance-number-color": "rgba(246,145,119,1)",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "redeem-button-color": "#556DD8",
                      "redeem-button-text": "REDEEM",
                      "redeem-button-text-color": "white",
                      "redeem-button-type": "filled_rectangle",
                      "redemption-1068729-displayname": "$100 OFF",
                      "redemption-1068729-settings-button-color": "rgba(246,145,119,1)",
                      "redemption-1068729-settings-button-text": "Redeem",
                      "redemption-1068729-settings-button-text-color": "#FFFFFF",
                      "redemption-1068729-settings-button-type": "rounded_filled_rectangle",
                      "redemption-1068729-settings-call-to-action-button-text": "Redeem",
                      "redemption-1068729-settings-cost": "10000",
                      "redemption-1068729-settings-cost-color": "#6C6C6C",
                      "redemption-1068729-settings-cost-font-size": "16",
                      "redemption-1068729-settings-cost-text": "{{points}} points",
                      "redemption-1068729-settings-coupon-cost-font-size": "15",
                      "redemption-1068729-settings-coupon-reward-font-size": "29",
                      "redemption-1068729-settings-discount-amount-cents": "10000",
                      "redemption-1068729-settings-discount-type": "fixed_amount",
                      "redemption-1068729-settings-reward": "$100 OFF",
                      "redemption-1068729-settings-reward-color": "#000000",
                      "redemption-1068729-settings-reward-font-size": "20",
                      "redemption-1068729-settings-success-message-text": "Discount Applied",
                      "redemption-591939-displayname": "$5.00 Off",
                      "redemption-591939-settings-button-color": "rgba(246,145,119,1)",
                      "redemption-591939-settings-button-text": "Redeem",
                      "redemption-591939-settings-button-text-color": "#FFFFFF",
                      "redemption-591939-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591939-settings-call-to-action-button-text": "Redeem",
                      "redemption-591939-settings-cost": 500,
                      "redemption-591939-settings-cost-color": "#6C6C6C",
                      "redemption-591939-settings-cost-font-size": "16",
                      "redemption-591939-settings-cost-text": "{{points}} points",
                      "redemption-591939-settings-coupon-cost-font-size": "15",
                      "redemption-591939-settings-coupon-reward-font-size": "29",
                      "redemption-591939-settings-discount-amount-cents": 500,
                      "redemption-591939-settings-discount-type": "fixed_amount",
                      "redemption-591939-settings-reward": "$5.00 OFF",
                      "redemption-591939-settings-reward-color": "#000000",
                      "redemption-591939-settings-reward-font-size": "20",
                      "redemption-591939-settings-success-message-text": "Discount Applied",
                      "redemption-591940-displayname": "$10.00 Off",
                      "redemption-591940-settings-button-color": "rgba(246,145,119,1)",
                      "redemption-591940-settings-button-text": "Redeem",
                      "redemption-591940-settings-button-text-color": "#FFFFFF",
                      "redemption-591940-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591940-settings-call-to-action-button-text": "Redeem",
                      "redemption-591940-settings-cost": 1000,
                      "redemption-591940-settings-cost-color": "#6C6C6C",
                      "redemption-591940-settings-cost-font-size": "16",
                      "redemption-591940-settings-cost-text": "{{points}} points",
                      "redemption-591940-settings-coupon-cost-font-size": "15",
                      "redemption-591940-settings-coupon-reward-font-size": "29",
                      "redemption-591940-settings-discount-amount-cents": 1000,
                      "redemption-591940-settings-discount-type": "fixed_amount",
                      "redemption-591940-settings-reward": "$10.00 OFF",
                      "redemption-591940-settings-reward-color": "#000000",
                      "redemption-591940-settings-reward-font-size": "20",
                      "redemption-591940-settings-success-message-text": "Discount Applied",
                      "redemption-591941-displayname": "$20.00 Off",
                      "redemption-591941-settings-button-color": "rgba(246,145,119,1)",
                      "redemption-591941-settings-button-text": "Redeem",
                      "redemption-591941-settings-button-text-color": "#FFFFFF",
                      "redemption-591941-settings-button-type": "rounded_filled_rectangle",
                      "redemption-591941-settings-call-to-action-button-text": "Redeem",
                      "redemption-591941-settings-cost": 2000,
                      "redemption-591941-settings-cost-color": "#6C6C6C",
                      "redemption-591941-settings-cost-font-size": "16",
                      "redemption-591941-settings-cost-text": "{{points}} points",
                      "redemption-591941-settings-coupon-cost-font-size": "15",
                      "redemption-591941-settings-coupon-reward-font-size": "29",
                      "redemption-591941-settings-discount-amount-cents": 2000,
                      "redemption-591941-settings-discount-type": "fixed_amount",
                      "redemption-591941-settings-reward": "$20.00 OFF",
                      "redemption-591941-settings-reward-color": "#000000",
                      "redemption-591941-settings-reward-font-size": "20",
                      "redemption-591941-settings-success-message-text": "Discount Applied",
                      "redemption-958424-displayname": "$50 off",
                      "redemption-958424-settings-button-color": "rgba(246,145,119,1)",
                      "redemption-958424-settings-button-text": "Redeem",
                      "redemption-958424-settings-button-text-color": "#FFFFFF",
                      "redemption-958424-settings-button-type": "rounded_filled_rectangle",
                      "redemption-958424-settings-call-to-action-button-text": "Redeem",
                      "redemption-958424-settings-cost": "5000",
                      "redemption-958424-settings-cost-color": "#6C6C6C",
                      "redemption-958424-settings-cost-font-size": "16",
                      "redemption-958424-settings-cost-text": "{{points}} points",
                      "redemption-958424-settings-coupon-cost-font-size": "15",
                      "redemption-958424-settings-coupon-reward-font-size": "29",
                      "redemption-958424-settings-discount-amount-cents": "5000",
                      "redemption-958424-settings-discount-type": "fixed_amount",
                      "redemption-958424-settings-reward": "$50 OFF",
                      "redemption-958424-settings-reward-color": "#000000",
                      "redemption-958424-settings-reward-font-size": "20",
                      "redemption-958424-settings-success-message-text": "Discount Applied",
                      "rule-border-color": "rgba(246,145,119,1)",
                      "rule-color": "#061153",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans\u0026display=swap",
                      "selected-extensions": [
                        "591939",
                        "591940",
                        "591941",
                        "958424",
                        "1068729"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "88787",
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "71861": {
                    instanceId: "71861",
                    instanceVersionId: "484081022",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.7.3-22.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "#0a0f5f",
                      "headline-font-size": "40",
                      "page-background-color": "",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "reward-opt-in-join-now-button-label": "Join now",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "Nunito Sans@400|https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "selected-widgets-ids": [
                        "71865",
                        "71863",
                        "71866",
                        "71862",
                        "71864"
                      ],
                      "widget-71863-type": "MyRewardsWidget",
                      "widget-71864-type": "ReferralWidget",
                      "widget-71865-type": "HeroSectionWidget",
                      "widget-71866-type": "CampaignWidget",
                      "widget-71867-type": "VisualRedemptionWidget"
                    },
                    staticContent: {
                      "platformName": "shopify",
                      "storeId": "02AULWMUXhDvrRViJWvFQ2ckFEi9F8NQdudLGeVH"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
            },
            guidStaticContent: {},
            dependencyGroups: {
                      "2": [
                        "https://cdn-widget-assets.yotpo.com/widget-vue-core/app.v0.1.0-2295.js"
                      ]
                    }
        },
        initializer: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widgets-initializer/app.v0.9.8-7487.js",
        analytics: "https://cdn-widgetsrepository.yotpo.com/widget-assets/yotpo-pixel/2026-03-10_12-14-30/bundle.js"
    }
    
    
    const initWidgets = function (config, initializeWidgets = true) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        return widgetInitializer.initWidgets(initializeWidgets);
    };
    const initWidget = function (config, instanceId, widgetPlaceHolder) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        if (widgetInitializer.initWidget) {
            return widgetInitializer.initWidget(instanceId, widgetPlaceHolder);
        }
        console.error("initWidget is not supported widgetInitializer");
    };
    const onInitializerLoad = function (config) {
        const prevInitWidgets = yotpoWidgetsContainer.initWidgets;
        yotpoWidgetsContainer.initWidgets = function (initializeWidgets = true) {
            if (prevInitWidgets) {
                if (typeof Promise !== 'undefined' && Promise.all) {
                    return Promise.all([prevInitWidgets(initializeWidgets), initWidgets(config, initializeWidgets)]);
                }
                console.warn('[deprecated] promise is not supported in initWidgets');
                prevInitWidgets(initializeWidgets);
            }
            return initWidgets(config, initializeWidgets);
        }
        const prevInitWidget = yotpoWidgetsContainer.initWidget;
        yotpoWidgetsContainer.initWidget = function (instanceId, widgetPlaceHolder) {
            if (prevInitWidget) {
              prevInitWidget(instanceId, widgetPlaceHolder)
            }
            return initWidget(config, instanceId, widgetPlaceHolder);
        }
        const guidWidgetContainer = getGuidWidgetsContainer();
        guidWidgetContainer.initWidgets = function () {
            return initWidgets(config);
        }
        guidWidgetContainer.initWidgets();
    };
    function getGuidWidgetsContainer () {
        if (!yotpoWidgetsContainer.guids) {
            yotpoWidgetsContainer.guids = {};
        }
        if (!yotpoWidgetsContainer.guids[guid]) {
            yotpoWidgetsContainer.guids[guid] = {};
        }
        return yotpoWidgetsContainer.guids[guid];
    }

    

    const guidWidgetContainer = getGuidWidgetsContainer();
    guidWidgetContainer.config = loader.config;
    if (!guidWidgetContainer.yotpo_widget_scripts_loaded) {
        guidWidgetContainer.yotpo_widget_scripts_loaded = true;
        guidWidgetContainer.onInitializerLoad = function () { onInitializerLoad(loader.config) };
        
        
        loader.loadDep(loader.analytics, function () {}, 'defer');
        
        
        
        loader.loadDep(loader.initializer, function () { guidWidgetContainer.onInitializerLoad() }, 'async');
        
    }
})()


